export const abTestConfig = [
  {
    // additional help to find the perfect ski for you
    // v1 original
    // v2 button with skifinder bot iframe addition
    // v3 button with simple slider form to find perfect ski
    // v4 additional help on every ski like "63% with intermediate skills were satisfied with this category"
    scope: 'skifinder',
    analyticsId: 'skifinder',
    versions: ['v1', 'v2', 'v3', 'v4', 'v5'],
    startDate: '2025-01-30',
    endDate: '2025-04-30'
  },
  {
    scope: 'hotelNavigation',
    analyticsId: 'hotelNavigation',
    versions: ['v1', 'v2'],
    startDate: '2025-01-30',
    endDate: '2026-05-01'
  },
  {
    scope: 'startPageVideo',
    analyticsId: 'startPageVideo',
    versions: ['v1', 'v2'],
    startDate: '2024-11-06',
    endDate: '2025-03-30'
  },
  {
    // links on shop pile navigate to PS (v2) or PS with open Shop Info (v3) on links
    scope: 'shopNavToPS',
    analyticsId: 'shopNavToPS',
    versions: ['v1', 'v2', 'v3'],
    startDate: '2025-01-24',
    endDate: '2025-04-30' //'2024-03-05'
  },
  {
    scope: 'fullscreenDatePicker',
    analyticsId: 'fullscreenDatePicker',
    versions: ['v1', 'v2'],
    startDate: '2024-09-01', //'2024-01-15',
    endDate: '2024-12-31' //'2024-03-05'
  },
  {
    // find out if people like help to copy data from other tabs
    scope: 'PsButler',
    versions: ['v1', 'v2'],
    analyticsId: 'AhoAihLkRWS7DyZUNXESsQ',
    startDate: '2024-09-15',
    endDate: '2024-09-16'
  },
  {
    // persons on the left and right side on PS are sticky (v2) or not (v1)
    scope: 'stickyPersonSettings',
    versions: ['v1', 'v2'],
    analyticsId: 'nUF8xqyXSNqb6bgUYebVWQ',
    startDate: '2025-01-24',
    endDate: '2025-04-30'
  },
  {
    // protect yourself part in checkout with checkboxes wihout marketing images
    scope: 'bindingAdjust',
    analyticsId: 'bindingAdjust',
    versions: ['v1', 'v2'],
    startDate: '2023-10-07',
    endDate: '2024-04-01'
  },
  {
    // control which payment will be used, used for new odin payment module
    scope: 'paymentProvider',
    analyticsId: 'paymentProvider',
    versions: [
      'v1',
      'v2',
      'v3',
      'v4',
      'v5',
      'v6',
      'v7',
      'v8',
      'v9',
      'v10',
      'v11',
      'v12',
      'v13',
      'v14',
      'v15',
      'v16',
      'v17',
      'v18',
      'v19',
      'v20'
    ],
    startDate: '2023-10-07',
    endDate: '2024-04-22'
  },
  {
    // Insurance upselling modal
    // v1 - with ability to add guarantee per person
    // v2 - strong wording, add to all
    // v3 - neutral wording, add to all
    scope: 'insuranceUpsellingModal',
    analyticsId: 'insuranceUpsellingModal',
    versions: ['v1', 'v2', 'v3'],
    startDate: '2025-01-21',
    endDate: '2025-04-21'
  },
  {
    // position of a payment component on a checkout page
    // v1 - original - at bottom
    // v2 - in the same section with the personal details
    // v3 - in the same section with the personal details + this section is moved to the bottom of the page, under upselling
    scope: 'paymentPosition',
    analyticsId: 'paymentPosition',
    versions: ['v1', 'v2', 'v3'],
    startDate: '2026-01-21',
    endDate: '2026-04-21'
  }
];
